import { useSelector } from 'react-redux';
import { UI } from '@leverege/ui-redux';
import { Toolbar } from '@leverege/ui-plugin';
import { Config } from '@leverege/plugin';
import { useMemo } from 'react';
import OverlayedImage from "./OverlayedImage.js";
import S from './OverlayDetailRenderer.css';
import useOverlay from "./useOverlay.js";
import { useOverlayKeyBindings } from "./rsrcGallery/hooks/index.js";
import { SHOW_OVERLAYS_KEY } from "../Constants.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function OverlayDetailRenderer(props) {
  const {
    rsrc,
    src,
    path,
    context: pContext
  } = props;
  const {
    clientProps: {
      delegate
    }
  } = pContext;
  const showOverlays = useSelector(state => {
    const show = UI.get(state, SHOW_OVERLAYS_KEY);
    return show == null ? true : show;
  });
  const {
    layers,
    loading
  } = useOverlay({
    item: rsrc,
    src,
    path,
    exclude: Config.get('OverlayDetailRenderer', 'excludeLayers')
  });
  const context = useMemo(() => {
    const layerKeys = Array.from(layers.reduce((prev, layer) => {
      if (layer.settingsKey) {
        prev.add(layer.settingsKey);
      }
      layer.data.forEach(datum => {
        if (datum.settingsKey) {
          prev.add(datum.settingsKey);
        }
      });
      return prev;
    }, new Set()));
    return {
      ...pContext,
      layers: layerKeys
    };
  }, [pContext, layers]);
  useOverlayKeyBindings();
  const matchContext = useMemo(() => {
    return {
      client: 'OverlayDetailRenderer',
      objectType: delegate.relationship.objectType,
      path: delegate.relationship.path
    };
  }, [delegate]);
  return /*#__PURE__*/_jsxs("div", {
    className: S.imageViewer,
    children: [loading && /*#__PURE__*/_jsx("div", {
      className: S.loader,
      children: /*#__PURE__*/_jsx("i", {
        className: "fa fa-fw fa-spin fa-spinner fa-3x"
      })
    }), /*#__PURE__*/_jsx(OverlayedImage, {
      overlaysEnabled: showOverlays,
      layers: layers,
      src: src,
      context: context
    }), /*#__PURE__*/_jsx(Toolbar, {
      layoutVariant: "flex:rowM",
      className: S.layerToolbar,
      matchContext: matchContext,
      context: context
    })]
  });
}